const getTypeData = (state, action) => {
  return { ...state, [action.model]: action.data };
};

const delData = (state, action) => {
  const data = { ...state[action.model] };
  delete data[action.id];
  return { ...state, [action.model]: data };
};

export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_TYPE_DATA':
      return getTypeData(state, action);
    case 'DEL_CLIENTS':
      return { ...state, clients: {} };
    case 'DEL_DATA':
      return delData(state, action);
    case 'LOGOUT':
      return {};
    default:
      return state;
  }
};
